/**
 * Shows a numeric input's value with a fixed number of decimal places (default 2) - "1" reads as
 * "1.00" - without changing the model, which stays a plain number. The value is formatted when the
 * model is loaded and again when the field loses focus, so it never fights the user mid-keystroke.
 *
 *   <input type="number" step="0.25" ng-model="eye.horizontal_prism" fixed-decimals="2" />
 */
app.directive("fixedDecimals", [
	function () {
		return {
			restrict: "A",
			require: "ngModel",
			link: function (scope, element, attrs, ngModel) {
				var places = parseInt(attrs.fixedDecimals, 10);
				if (isNaN(places)) places = 2;

				function format(value) {
					if (value === null || value === undefined || value === "" || isNaN(value)) return "";
					return Number(value).toFixed(places);
				}

				// Formatters run last-to-first, and a number input's own formatter throws on anything
				// but a number - so this one goes first in the list, to run after it on its string.
				ngModel.$formatters.unshift(format);

				element.on("blur", function () {
					var text = format(ngModel.$modelValue);
					if (text !== "" && element.val() !== text) {
						element.val(text);
					}
				});
			},
		};
	},
]);
